import Ajax from '../common/ajax'

export default {
  model: 'enroll',
  getCurrentTime () {
    return Ajax.get(`/api/gugongExaminee/v1/common/currentTime`)
  },
  getUserInfo () {
    return Ajax.get(`/api/gugongExaminee/v1/user/info`)
  },
  getLastEnrollInfo () {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/lastEnrollInfo`)
  },
  async getSpecialtyList (batchId) {
    let categoryList = await Ajax.get(`/api/gugongExaminee/v1/enroll/listSpecialty/${batchId}`)
    let list = []
    for (let i in categoryList) {
      let category = categoryList[i]
      let children = []
      for (let j in category.specialtyResponses) {
        let specialty = category.specialtyResponses[j]
        children.push({ id: specialty.specialtyId, name: specialty.specialtyName, parentId: `${category.categoryName}###${category.sort}` })
      }
      list.push({ id: `${category.categoryName}###${category.sort}`, name: category.categoryName, parentId: '', children: children })
    }
    return list
  },
  getGradeList (specialtyId) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/listGrade/${specialtyId}`)
  },
  getAreaList () {
    return Ajax.get(`/api/gugongExaminee/v1/common/listArea`)
  },
  getNationalityList () {
    return Ajax.get(`/api/gugongExaminee/v1/common/nationality`)
  },
  getAgentList (gradeId, areaId) {
    return Ajax.post('/api/gugongExaminee/v1/enroll/listAgent', { agentAddress: areaId, gradeId: gradeId })
  },
  getExamInfo (id) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/enrollDetail/${id}`)
  },
  getExamSubjectList (id) {
    return Ajax.get(`/api/gugongExaminee/v1/${this.model}/listExamSubject/${id}`)
  },
  getSubjectGroupList (id) {
    return Ajax.get(`/api/gugongExaminee/v1/${this.model}/listSubjectGroup/${id}`)
  },
  commitExamEnroll (form = {}, subjectList = []) {
    let data = {
      certificateName: form.certificateName,
      certificateNo: form.certificateNo,
      certificateUrl: form.certificateUrl,
      examId: form.examId,
      examineeAuthRequest: {
        birthday: form.birthday,
        country: form.country,
        countryCode: form.countryCode,
        examineeIdNo: form.examineeIdNo,
        examineeName: form.examineeName,
        examineeNameSpell: form.examineeNameSpell,
        examineeSex: form.examineeSex,
        idType: form.idType,
        nationality: form.nationality,
        nationalityCode: form.nationalityCode,
        officialPhoto: form.officialPhoto
      },
      gradeAgentId: form.gradeAgentId,
      receiverAddressDetail: form.receiverAddressDetail,
      receiverAddressInfo: form.receiverAddressInfo,
      receiverName: form.receiverName,
      receiverPhone: form.receiverPhone,
      subjectGroupId: form.subjectGroupId,
      subjectGroupName: form.subjectGroupName,
      teacherName: form.teacherName,
      teacherPhone: form.teacherPhone,
      subjectList: subjectList
    }
    return Ajax.post(`/api/gugongExaminee/v1/${this.model}/commitExamEnroll`, data)
  },
  getOrderRes (orderId) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/${orderId}`)
  },
  checkAuth (data = {}) {
    return Ajax.post(`/api/gugongExaminee/v1/user/checkAuth`, data)
  },
  checkEnroll (gradeId) {
    return Ajax.get(`/api/gugongExaminee/v1/enroll/checkEnroll/${gradeId}`)
  }
}
